import React from 'react';

const StarFull: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path d="M15.715 6.75c0.178-0.173 0.244-0.38 0.183-0.567s-0.236-0.315-0.482-0.351l-4.415-0.642c-0.197-0.029-0.456-0.217-0.544-0.395l-1.974-4.001c-0.11-0.222-0.286-0.35-0.483-0.35s-0.373 0.127-0.483 0.35l-1.974 4.001c-0.088 0.178-0.347 0.367-0.544 0.395l-4.415 0.642c-0.245 0.036-0.421 0.164-0.482 0.351s0.006 0.394 0.184 0.567l3.195 3.114c0.142 0.139 0.242 0.444 0.208 0.639l-0.754 4.397c-0.043 0.253 0.034 0.408 0.106 0.493 0.15 0.178 0.414 0.212 0.675 0.074l3.949-2.076c0.167-0.088 0.506-0.088 0.672 0l3.949 2.076c0.109 0.058 0.216 0.086 0.319 0.086 0.142 0 0.269-0.057 0.356-0.161 0.072-0.086 0.149-0.241 0.106-0.493l-0.754-4.397c-0.034-0.196 0.065-0.501 0.208-0.639l3.195-3.114z"></path>
    </svg>
  );
};

export { StarFull };
